import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalIngresarComponent } from '../modal-ingresar/modal-ingresar.component';
import { fromEvent, lastValueFrom, throwError } from 'rxjs';
import { switchMap, catchError, finalize } from 'rxjs/operators';
import { ModalConsultaRfcComponent } from '../modal-consulta-rfc/modal-consulta-rfc.component';
import Swal from 'sweetalert2';
import { INormaModelInput, IResponseModel } from 'src/app/models/seguros-atlas/atlas.model';
import { NotificacionesPushService } from 'src/app/services/auth/notificaciones-push.service';
import { IResponse2FA } from 'src/app/models/account/account.model';
import { SistemaOperativoService } from 'src/app/services/sistema-operativo/sistema-operativo.service';

import { FormsModule } from '@angular/forms';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { RegistroAseguradoComponent } from './registro-asegurado/registro-asegurado.component';
import { RegistroAgenteComponent } from './registro-agente/registro-agente.component';
import { RegistroProveedorComponent } from './registro-proveedor/registro-proveedor.component';
import { RegistroPromotorComponent } from './registro-promotor/registro-promotor.component';
import { RegistroReaseguradorComponent } from './registro-reasegurador/registro-reasegurador.component';
import { RegistroEmpleadoComponent } from './registro-empleado/registro-empleado.component';
import { RegistroEjecutivoComponent } from './registro-ejecutivo/registro-ejecutivo.component';
import { RegistroAgenteUdiComponent } from './registro-agente-udi/registro-agente-udi.component';
import { VersionCheckerService } from 'src/app/services/utilidades/version-checker.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [FormsModule, MatFormField, MatInput, MatError, MatButton, RegistroAseguradoComponent, RegistroAgenteComponent, RegistroProveedorComponent, RegistroPromotorComponent, RegistroReaseguradorComponent, RegistroEmpleadoComponent, RegistroEjecutivoComponent, RegistroAgenteUdiComponent]
})
export class LoginComponent implements OnInit {
  imagen: string;
  loading = false;
  loadingVersion = false;
  validandoRegistro = false;
  show = true;
  show2 = false;
  Ventana = true;
  Asegurado = false;
  Agente = false;
  Proveeedor = false;
  Promotor = false;
  Reasegurador = false;
  Empleado = false;
  Ejecutivo = false;
  AgenteUdi = false;

  credentials = {
    Usuario: '',
    Password: '',
    RememberMe: false
  };

  msg = fromEvent<MessageEvent>(window, "message");

  public versionCheckService = inject(VersionCheckerService);

  constructor(private authService: AuthService,
              private snackBar: MatSnackBar,
              private dialog: MatDialog,
              private router: Router,
              private notiPushService: NotificacionesPushService,
              private soService: SistemaOperativoService,
              private rutaActiva: ActivatedRoute,) {

                this.validarRuta();
               }

  ngOnInit() {
    sessionStorage.removeItem('AP-IN');
    this.cargarUsuarioRegistrado();
    this.obtenerDatosCotizador();

    if (localStorage.getItem('AP-TK')) { this.router.navigate(['primeraPagina']); }
    if (sessionStorage.getItem('adios')) {
      const msgError = 'Se ha iniciado sesión en otro dispositivo o tus credenciales han expirado, vuelve a ingresar';
      setTimeout(() => {
        this.abrirSnackBar(msgError, `Autentificación`, 'errorSnackbar');
        sessionStorage.removeItem('adios');
      }, 200);
    }

    this.imagenAleatoria();

    //   this.notiPushService.generarTokenFirebase().subscribe(
    //   token => {
    //     if(token) console.log('Ok');
    //   },
    //   error => {
    //     console.log('Error al obtener el token de notificaciones:', error);
    //   }
    // );
  }


  // Recibe token por 'postMessage'
  obtenerDatosCotizador() {
    this.msg.subscribe(event => {

      if (event.data.aptk && event.data.apdp  && event.data.aprtk  && event.data.port) {
        localStorage.setItem('AP-TK', event.data.aptk.value);
        localStorage.setItem('AP-DP', event.data.apdp.value);
        localStorage.setItem('AP-RTK', event.data.aprtk.value);
        localStorage.setItem('DATA-PORT', event.data.port.value);
        this.router.navigate(['/']);
      }
    });
  }

  modificarUsuario() {
    this.credentials.Password ? this.credentials.Password = '' : null;
  }

  private abrirSnackBar(mensaje: string, titulo: string, clase: string) {
    const config: MatSnackBarConfig = {
      duration: 5000,
      panelClass: clase,
    };
    this.snackBar.open(mensaje, titulo, config);
  }

  imagenAleatoria() {
    this.imagen = `assets/img/${Math.floor((Math.random() * Math.floor(5)) + 1)}.jpg`;
    setTimeout(() => {
      this.imagenAleatoria();
    }, 30000);
  }

  async notificarVersionDisponible() {
    try {
      this.loadingVersion = true;
      this.abrirSnackBar(`Validando versión del portal, espere un momento`, `Aviso`, '');
      const versionValida = await lastValueFrom(this.versionCheckService.obtenerVersion());
      this.loadingVersion = false;
      this.versionCheckService.validarVersion(versionValida);
      if (this.versionCheckService.versionNotificada) {
        this.versionCheckService.mostrarSnackBarVersionNueva();
      } else {
        this.abrirModal();
      }
    } catch (error) {
      this.loadingVersion = false;
      this.abrirModal();
    }
  }

  abrirModal(){
    this.loading = true;

    this.authService.limpiarTokens(false);

    this.authService.validaSesion(this.credentials.Usuario).subscribe(
      (res) => {

         if(this.soService.getInformacionDevice().isDesktop === 'Mac'){
          
          this.notiPushService.generarTokenMacOs(50).subscribe(
            async (token) => {
              
            this.obtenerAlias(token);
  
            },
            error => {
              this.loading = false;
              console.log('Error al obtener el token de notificaciones:', error);
            }
          );

        }else{
          
           this.notiPushService.generarTokenFirebase().subscribe(
            async (token) => {
              
            this.obtenerAlias(token);
  
            },
            error => {
              this.loading = false;
              console.log('Error al obtener el token de notificaciones:', error);
            }
          );
        }

      },
      (error) => {
        this.loading = false;
        Swal.fire({ title: `¡Atención!`, icon: 'error', text: error?.error[0]?.Exception, confirmButtonText: 'Aceptar'});

        if (error?.error[0]?.Key == "Usuario") 
          return this.abrirSnackBar(`Ya existe una sesión abierta con el usuario ${this.credentials.Usuario}`, `cerrar`, 'errorSnackbar');
  
        this.abrirSnackBar('Verifique su nombre de usuario', `Autentificación`, 'errorSnackbar');
      }
    );
  }

  Display() {
    this.Ventana=false;
  }

  irARegistro(): void {
    if (this.validandoRegistro) {
      return;
    }

    this.validandoRegistro = true;

    this.authService.validarDisenoRegistro()
      .pipe(
        finalize(() => {
          this.validandoRegistro = false;
        })
      )
      .subscribe(
        (respuesta: any) => {
          const valor = Number(respuesta?.Respuesta?.valor || 0);

          if (valor === 1) {
            this.router.navigate(['/login/registrate']);
            return;
          }

          this.Display();
        },
        () => {
          this.Display();
        }
      );
  }

  irRegistroProspectoProveedor() {
    this.router.navigate(['/proveedores/mesa-control/siniestros/prospectos-proveedores']);
  }

  irActualizarFacturacion() {
    this.router.navigate(['/facturacion/actualizacion-csf']);
  }

  irAConsultarDatosActualizados() {
    const dialogRef = this.dialog.open(ModalConsultaRfcComponent, {
      // height: '90%',
      width: '400px'
    })
  }

  verAsegurado(x) {

    if ( x === 'A') {
      this.show = false
      this.show2 = true;
      this.Asegurado = true; //Si x es === a 'A' abre la  ventana de Asegurado
    } else if ( x === 'Ag') {
      this.show = false
      this.show2 = true;
      this.Agente = true; //si x es === a 'Ag' abre la ventana de Agente
    } else if (x === 'Proveedor') {
      this.show = false
      this.show2 = true;
      this.Proveeedor = true;
    }else if (x === 'Promotor') {
      this.show = false
      this.show2 = true;
      this.Promotor = true;
    }else if (x === 'Reasegurador') {
      this.show = false
      this.show2 = true;
      this.Reasegurador = true;
    }
    else if (x === 'Empleado') {
      this.show = false
      this.show2 = true;
      this.Empleado = true;
    }else if (x === 'Ejecutivo') {
      this.show = false
      this.show2 = true;
      this.Ejecutivo = true;
    } else if ( x === 'AgUdi') {
      this.show = false
      this.show2 = true;
      this.AgenteUdi = true;
    }
  }
  regresar(){
    this.Ventana = true;
    this.show = true;
    this.show2 = false;
    this.Agente = false;
    this.Asegurado = false;
    this.Proveeedor = false;
    this.Promotor = false;
    this.Reasegurador = false;
    this.Empleado = false;
    this.Ejecutivo = false;
    this.AgenteUdi = false;

    this.router.navigate(['/login'], {
      replaceUrl: true
    });
  }

  private cargarUsuarioRegistrado(): void {
    const usuarioRegistrado = sessionStorage.getItem('AC-REG-USUARIO');

    if (!usuarioRegistrado) {
      return;
    }

    this.credentials.Usuario = usuarioRegistrado;
    sessionStorage.removeItem('AC-REG-USUARIO');

    this.modificarUsuario();
  }

obtenerAlias(token: string){
            this.authService.obtenerAlias(this.credentials.Usuario, token == null ? '123sddsfewr' : token).subscribe(
              (data) => {
                
                let response2FA: IResponse2FA = data as any;

                const norma: INormaModelInput = {
                  NumNorma: 756,
                  Parametro1: 0,
                  Parametro2: 0,
                  Parametro3: 0,
                };

                this.authService.obtenerNormaAtlas(norma).subscribe(
                  (res: IResponseModel) => {
                    if (res.Respuesta.Status == 1) {
                      Swal.fire({
                        title: `¡Informativo!`,
                        icon: 'info',
                        html: `Estimados usuarios, <br/>
                                Les informamos que hemos actualizado los envíos de correo de nuestro servicio 
                                Cero Papel. Si recibiste un correo con el asunto <b>"Notificación Paperless"</b>, por favor, ignóralo. 
                                A partir de ahora, los correos de Cero Papel se enviarán con el asunto 
                                <b>"Notificación Seguros Atlas CeroPapel"</b>. <br/>
                                Agradecemos su atención y comprensión.
                              `,
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false,
                      });
                    }
                  },
                  (error) => {
                    Swal.fire({
                      title: 'Aviso',
                      text: 'Ups ocurrió algo mientras consultabamos los datos',
                      icon: 'error',
                    });
                  }
                );
                        
                const configModal: MatDialogConfig<any> = {
                  data: { alias: response2FA.datos.Alias, login: this.credentials, excepcion: response2FA.datos.isExcepcion2FA }
                };
                const dialogRef = this.dialog.open(ModalIngresarComponent, configModal).afterClosed().subscribe(() => {
                  this.loading = false;
                });
              },
              (error) => {
                this.loading = false;
                if(error.error.message == "ValidarUsuarioInhabilitado2FA")
                  this.abrirSnackBar(error.error.errorDescripcion, 'Autenticación', 'errorSnackbar');
                else
                  this.abrirSnackBar('Error al obtener el alias', 'Autenticación', 'errorSnackbar');
              }
        );
}

  validarRuta(): void {
    const ruta = this.rutaActiva.snapshot.params['ruta'];

    const mostrarRegistroLegacy =
      this.rutaActiva.snapshot.queryParamMap.get('registro') === 'legacy';

    if (mostrarRegistroLegacy) {
      this.Display();
      return;
    }

    if (!ruta) {
      return;
    }

    if (ruta === 'registrate') {
      this.Display();
      return;
    }

    this.router.navigate(['/login']);
  }

}
